export const SEEN_MRN_SYSTEM = 'https://www.seenehr.com/mrn'

/** meta.source value set by Medplum's Health Gorilla integration on created resources */
export const HEALTH_GORILLA_META_SOURCE = 'https://www.healthgorilla.com'

/** Identifier system Health Gorilla's Medplum bot writes on its DiagnosticReports and DocumentReferences */
export const HEALTH_GORILLA_IDENTIFIER_SYSTEM = 'https://www.healthgorilla.com'

/** Category system the bot uses to type its DocumentReferences: DiagnosticReport, LabOrderRequisition, SpecimenLabel */
export const HEALTH_GORILLA_DOCUMENT_TYPE_SYSTEM =
  'https://www.medplum.com/integrations/health-gorilla/document-type'

/** FHIR profile for Health Gorilla grouping Observations (note: "observaton" typo is in the actual URL) */
export const HEALTH_GORILLA_OBSERVATION_GROUP_PROFILE =
  'https://healthgorilla.com/fhir/StructureDefinition/hg-observaton-group'

export const ELATION_FEED_ITEM_ID_QUERY_PARAM = 'itemId'

export const SEEN_ACTION_QUERY_PARAM = 'seen_action'
export const SEEN_ACTION_DRAFT_ID_QUERY_PARAM = 'draft_id'
export const SEEN_ACTION_PHARMACY_QUERY_PARAM = 'pharmacy_query'
export const SEEN_ACTION_PHARMACY_NAME_QUERY_PARAM = 'pharmacy_name'
export const SEEN_ACTION_OPEN_UNSIGNED_DRAFT_QUERY_PARAM = 'open_unsigned_draft'

// https://coda.io/d/Seen-Health-Team-Hub_dnQFL_vbdlB/SGV-Service-Area-Zip-Codes_suT1yGys?searchClick=5e3c070c-4083-48e4-874e-91a12a63dab2_nQFL_vbdlB#_luiX5DSg
export const SERVICE_AREA_ZIP_CODES = [
  '90004',
  '90005',
  '90006',
  '90007',
  '90012',
  '90013',
  '90014',
  '90015',
  '90017',
  '90018',
  '90019',
  '90021',
  '90022',
  '90023',
  '90026',
  '90031',
  '90032',
  '90033',
  '90039',
  '90040',
  '90041',
  '90042',
  '90057',
  '90063',
  '90065',
  '90071',
  '90640',
  '91007',
  '91006',
  '91024',
  '91030',
  '91101',
  '91103',
  '91104',
  '91105',
  '91106',
  '91107',
  '91108',
  '91204',
  '91205',
  '91731',
  '91732',
  '91733',
  '91754',
  '91755',
  '91770',
  '91775',
  '91776',
  '91780',
  '91801',
  '91803',
]
